import { useEffect, useRef } from 'react'
import type { Subgeo } from '../types'
import type { AggregateCache, TooltipCache } from '../utils/tooltip-utils'

export const useSubgeoCacheInvalidation = (
	subgeos: Subgeo[],
	tooltipCache: TooltipCache,
	aggregateCache: AggregateCache,
	subgeoLookup: Map<string, Subgeo>
) => {
	const prevSubgeosRef = useRef<Map<string, string[]>>(new Map())

	useEffect(() => {
		const currentSubgeos = new Map<string, string[]>()

		for (const subgeo of subgeos) {
			currentSubgeos.set(subgeo.id, [...subgeo.neighborhoodIds].sort())
		}

		for (const [subgeoId, prevNeighborhoods] of prevSubgeosRef.current) {
			const currentNeighborhoods = currentSubgeos.get(subgeoId)

			if (
				!currentNeighborhoods ||
				prevNeighborhoods.join(',') !== currentNeighborhoods.join(',')
			) {
				aggregateCache.delete(subgeoId)
				tooltipCache.deleteBySubgeoId(subgeoId, subgeoLookup)
			}
		}

		prevSubgeosRef.current = currentSubgeos
	}, [subgeos, tooltipCache, aggregateCache, subgeoLookup])
}
